import React from 'react';
import Breadcrumb from '../../components/breadcrumb/breadcrumb';
import Sidebar from '../../components/sidebar/sidebar';
import DetailedProduct from '../../components/product/detailedProduct';
import DetailsHeading from '../../components/detailsHeading/detailsHeading';
import CardIngredients from '../../components/card/cardIngredients';
import CardNutritional from '../../components/card/cardNutritional';
import SuggestedProductsHeading from '../../components/product/suggestedProductsHeading';
import DiscoverProduct from '../../components/product/discoverProduct';
import HorizontalMenu from '../../components/sidebar/horizontalMenu';
import RotatingDiv from '../../components/rotatingDiv/rotatingDiv';

//import product images
import originalberry from '../../images/products/originalberry.png';
import originaljam from '../../images/products/original.png';
import extra from '../../images/products/extra.png';
import pickles from '../../images/products/pickles.png';

function BerriesSauce() {
    const suggestions = [
        {
            name: 'Doce de Physalis',
            photo: originaljam,
            link: '/originaljam',
            className: 'physalina-link',
        },
        {
            name: 'Compota Extra de Physalis',
            photo: extra,
            link: '/originalextrajam',
            className: 'physalina-link',
        },
        {
            name: 'Bagas desidratadas',
            photo: originalberry,
            link: '/originalberry',
            className: 'physalina-link',
        },
    ];

    return (
        <>
            <div className="horizontal-menu">
                <HorizontalMenu />
            </div>
            <div className="breadcrumb-container">
                <Breadcrumb
                    home="Home"
                    section="Produtos"
                    category="Bagas de Physalis"
                    name="Bagas em Pickles"
                ></Breadcrumb>
            </div>
            <div className="product-details-grid">
                <div className="sidebar-menu padding-top30 padding-left50">
                    <Sidebar />
                </div>
                <DetailedProduct
                    photo={pickles}
                    name="Pickles de Physalis"
                    color="orange-text"
                    category="Bagas de Physalis"
                    description="De um sabor algo exótico, com uma textura inigualável e um agridoce inexplicável, torna estes pickles únicos.
                    Excelentes para enriquecer todos os pratos que acompanhem."
                    weight="Frasco de 200ml / Peso escorrido 90g"
                    link="/contacts"
                    buttonColor="btn--original"
                    buttonText="Online"
                ></DetailedProduct>
                <div className="details">
                    <div className="details-title">
                        <DetailsHeading
                            text="Detalhes"
                            type="original"
                        ></DetailsHeading>
                    </div>
                    <div className="cards">
                        <div className="card-ingridients-container">
                            <CardIngredients
                                ingredient="Vinagre de vinho branco"
                                specialIngredient="Água"
                                secondSpecialIngredient="Pimenta preta"
                                salt="yes"
                                sulfitos="yes"
                            />
                            <RotatingDiv>
                                <div className="svg-original-berry solid-pattern-container"></div>
                            </RotatingDiv>
                        </div>
                        <div className="card-nutritional-container">
                            <CardNutritional
                                energy="424 kj / 101 kcal"
                                lipids="0.21 g"
                                saturados="0.00 g"
                                hydrates="23.77 g"
                                sugars="21.62 g"
                                fiber="1.32 g"
                                proteins="1.06 g"
                                salt="0.94 g"
                            ></CardNutritional>
                            <RotatingDiv>
                                <div className="svg-original-berry solid-pattern-container2"></div>
                            </RotatingDiv>
                        </div>
                    </div>
                </div>
                <div className="suggestions-heading">
                    <SuggestedProductsHeading
                        question="É fã do sabor original da Physalis?"
                        answer="Originalidade é connosco:"
                        color="orange-text"
                    ></SuggestedProductsHeading>
                </div>
                <div className="discover-section-grid">
                    {suggestions.map((discoverProduct, idx) => (
                        <DiscoverProduct
                            key={idx}
                            discoverProduct={discoverProduct}
                        />
                    ))}
                </div>
            </div>
        </>
    );
}

export default BerriesSauce;
